export default __webpack_public_path__ + "static/media/persona-plshldr.64bb8bd3.jpg";